/**
 * @generated SignedSource<<ae5bdc9f09eb0cd7fe40f0255ee419cc>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type SyncPageRefreshQuery$variables = {};
export type SyncPageRefreshQuery$data = {
  readonly viewer: {
    readonly syncReady: boolean | null;
  };
};
export type SyncPageRefreshQuery = {
  response: SyncPageRefreshQuery$data;
  variables: SyncPageRefreshQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "syncReady",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "SyncPageRefreshQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          (v0/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "SyncPageRefreshQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          (v0/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "f52c921375398aa60b97fd45981bd5dc",
    "id": null,
    "metadata": {},
    "name": "SyncPageRefreshQuery",
    "operationKind": "query",
    "text": "query SyncPageRefreshQuery {\n  viewer {\n    syncReady\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "170311ae15506466a70ab61f67f0d6f7";

export default node;
